import {FC} from 'react'
import {useIntl} from 'react-intl'
import {LazyLoadImage} from 'react-lazy-load-image-component'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {ItemStatus} from '../../orders/constants'
import {useAppSelector} from '../../../../setup/redux/hooks'
import {selectItemList} from '../redux/itemRedux'

interface Props {
  currentItemId: number
  onSelect: (id: number) => void
}

const ItemOrderList: FC<Props> = ({currentItemId, onSelect}) => {
  const intl = useIntl()
  const orderItems = useAppSelector(selectItemList)

  // Don't show the list if there are no items or only 1 item
  if (!orderItems || orderItems.length <= 1) {
    return null
  }

  return (
    <div className='card mt-6'>
      <div className='card-header'>
        <h3 className='card-title fw-bolder'>
          {intl.formatMessage({id: 'OrderDetail.header.ORDER_ITEMS'})}
        </h3>
      </div>
      <div className='card-footer py-5 text-center d-flex overflow-auto'>
        {orderItems.map((item) => {
          const targetImg =
            item.status === ItemStatus.DONE ? item.outputImageUrl?.tiny : item.inputImageUrl?.tiny
          return (
            <div key={item.id} className='position-relative'>
              <LazyLoadImage
                height={'120px'}
                placeholderSrc={toAbsoluteUrl('/media/loading-bg.gif')}
                style={{
                  paddingLeft: '20px',
                  paddingRight: '20px',
                  cursor: 'pointer',
                }}
                src={targetImg}
                alt={item.name}
                onClick={() => onSelect(item.id)}
                effect='opacity'
                onError={(event: any) => {
                  if (event?.target?.src) event.target.src = toAbsoluteUrl('/media/loading-bg.gif')
                }}
              />
              {item.id === currentItemId && (
                <i
                  style={{
                    top: '10px',
                    right: '30px',
                  }}
                  className='position-absolute text-success fs-2 bi bi-check-circle-fill'
                ></i>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ItemOrderList
